import React from "react";
import styles from './slogon.module.scss'
import slogonImg from 'images/GPremium-brand.svg'
export const Slogan = (props) => {
    const {className, src} = props;
    return <div className={`${styles.container} ${className}`}>
        <img className={styles.slognImg} src={src || slogonImg} alt='slogan'/>
    </div>
};
